import { BinaryQuestion } from '@comeon/ui';
import { getZindexByType } from '~/utils/style-utils';

const Z_INDEX = 'modal';

const getText = (tr, isSelfExcluded) => {
	if (isSelfExcluded) {
		return {
			title: tr.MARKETPLACE_SELF_EXCLUDED_TITLE,
			message: tr.MARKETPLACE_SELF_EXCLUDED_SUBTITLE,
			confirmMessage: tr.MARKETPLACE_NL_U24_GOT_IT,
			rejectMessage: tr.MARKETPLACE_NL_U24_GO_TO
		};
	}
	return {
		title: tr.MARKETPLACE_NL_U24_TITLE,
		message: tr.MARKETPLACE_NL_U24_SUBTITLE,
		confirmMessage: tr.MARKETPLACE_NL_U24_GOT_IT,
		rejectMessage: tr.MARKETPLACE_NL_U24_GO_TO
	};
};

const MarketplacePopup = ({ translations: tr = {}, onConfirm, onReject, isSelfExcluded, isBonusBlocked }) => {
	const { title, message, confirmMessage, rejectMessage } = getText(tr, isSelfExcluded);
	return (
		<BinaryQuestion
			title={title}
			message={message}
			confirmMessage={confirmMessage}
			rejectMessage={onReject && !isBonusBlocked ? rejectMessage : null}
			onConfirm={onConfirm}
			onReject={onReject}
			zIndex={getZindexByType(Z_INDEX)}
			vertical
		/>
	);
};

export default MarketplacePopup;
